import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { ObtenerDatosService } from 'src/app/servicios/datos/obtener-datos/obtener-datos.service';

@Component({
  selector: 'app-pregunta-inicio',
  templateUrl: './pregunta-inicio.component.html',
  styleUrls: ['./pregunta-inicio.component.scss']
})
export class PreguntaInicioComponent implements OnInit {

  disableUrna = false;

  constructor(
    private readonly globalService: GlobalesService,
    public obtenerDatosService: ObtenerDatosService,
  ) { }

  ngOnInit(): void {
    this.globalService.menuActual = 'PreguntasFrecuentes';
    this.globalService.unselectContiendas();
    this.obtenerDatosService.configSubject.subscribe(data =>{
      if(data == null) return;
      this.disableUrna = data?.disable_urna;
    });
  }

}
